export function TextualSettingItem({
  title = '',
  link = '',
  icon = 'image-add',
  desc = '',
  templates = [],
}) {
  this.title = title;
  this.link = link;
  this.icon = icon;
  this.desc = desc;
  this.templates = templates;
}
